import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putLanguage = (token, id, IsoLanguage, Description) => {
    return fetch(`${apiUrl}languages/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            IsoLanguage,
            Description
        })
    });
}

export default putLanguage